import useFavicon from "hooks/useFavicon";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isInternetExplorer } from "utils/browser";
import { setMetaDescription } from "utils/dom";
import Footer from "../Footer";
import UnsupportedBrowserPage from "../UnsupportedBrowserPage";
import Advantages from "./Advantages";
import Head from "./Head";
import Message from "./Message";
import ParkingMeter from "./ParkingMeter";

const StreetPage: React.FC = () => {
  const { t } = useTranslation();

  useFavicon("/favicon-street.svg");

  useEffect(() => {
    document.title =
      t("10702"); /* iParque Street –  Parquímetro Inteligente  */

    setMetaDescription(
      t(
        "10703"
      ) /* O parquímetro inteligente para a sua cidade e o primeiro no país com MB Way. Rentabilize o seu investimento! */
    );

    return () => {
      document.title =
        t(
          "10694"
        ) /* iParque OnStreet – Gestão de Estacionamento para concessionárias */;

      setMetaDescription(
        t(
          "10695"
        ) /* Controlo e monitorização de zonas, ruas e equipas de fiscalização. A solução para a sua concessionária! */
      );
    };
  }, [t]);

  return isInternetExplorer ? (
    <UnsupportedBrowserPage />
  ) : (
    <>
      <Head />
      <Advantages />
      <ParkingMeter />
      <Message />
      <Footer />
    </>
  );
};

export default StreetPage;
